import React, { useEffect, useState } from "react";
import { Building2, CheckCircle2, Download, FileText, ShieldAlert } from "lucide-react";
import "../components/coordination/coordination.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STATUS_LABEL = { OK: "Presente agli atti", EXPIRED: "Scaduto", ACK: "Presa visione", MISSING: "Da trasmettere" };

export default function DocRequestPage({ token }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    fetch(`${API}/public/doc-request/${token}`)
      .then(async response => {
        if (!response.ok) throw new Error((await response.json().catch(() => ({}))).detail || "Richiesta non disponibile");
        return response.json();
      })
      .then(setData)
      .catch(err => setError(err.message));
  }, [token]);

  if (error) return <main className="doc-request-page" data-testid="doc-request-error">
    <ShieldAlert size={28} /><h1>Richiesta non disponibile</h1><p>{error}</p>
  </main>;
  if (!data) return <main className="doc-request-page" data-testid="doc-request-loading"><p>Caricamento…</p></main>;

  return <main className="doc-request-page" data-testid="doc-request-page">
    <img src="/brand/ingego-mark.png" alt="ingego" className="doc-request-logo" />
    <p className="eyebrow">VERIFICA IDONEITÀ TECNICO-PROFESSIONALE</p>
    <h1 data-testid="doc-request-title">Richiesta documenti {data.template === "autonomo" ? "per lavoratore autonomo" : "per impresa"}</h1>
    <div className="doc-request-meta">
      <span><Building2 size={14} />{data.company_name}</span>
      <span>Cantiere: <strong data-testid="doc-request-site">{data.site_name}</strong>{data.site_address ? ` · ${data.site_address}` : ""}</span>
      {data.practice_name && <span>Pratica: {data.practice_name}</span>}
      <span>Richiesta dal tecnico: {data.studio}</span>
    </div>

    <div className="doc-request-actions">
      <a className="primary" href={`${API}/public/doc-request/${token}/pdf`} target="_blank" rel="noopener noreferrer" data-testid="doc-request-pdf">
        <FileText size={15} />Visualizza il PDF della richiesta
      </a>
      <a className="ghost" href={`${API}/public/doc-request/${token}/pdf?fmt=docx`} data-testid="doc-request-docx">
        <Download size={15} />Scarica in Word
      </a>
    </div>

    <ul className="doc-request-list" data-testid="doc-request-list">
      {data.documents.map(item => <li key={item.label} className={item.status === "MISSING" ? "pending" : "done"}>
        {item.status === "MISSING" ? <ShieldAlert size={14} /> : <CheckCircle2 size={14} />}
        <span>{item.label}{item.mandatory && <em> · obbligatorio per l'ingresso</em>}</span>
        <small>{STATUS_LABEL[item.status] || item.status}</small>
      </li>)}
    </ul>
    <p className="doc-request-foot">La documentazione va trasmessa al tecnico entro 7 giorni dal ricevimento della presente richiesta.
      In mancanza dei documenti obbligatori non è consentito l'accesso in cantiere.</p>
  </main>;
}
